import apiClient from '../lib/apiClient';

const contentService = {
  listContents() {
    return apiClient.request('/user/posts');
  },
  generatePost(payload) {
    return apiClient.request('/posts/generate', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  },
  generateByEndpoint(endpoint, payload, options = {}) {
    return apiClient.request(endpoint, {
      method: 'POST',
      body: JSON.stringify(payload),
      ...options
    });
  },
  myVideos() {
    return apiClient.request('/my-videos');
  },
  editImage(payload) {
    return apiClient.request('/edit-image', {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};

export default contentService;
